import {SET_CRITERIAS_LIST, SET_CRITERIAS_LOADING} from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";


export const getList = (paramsOrIncludeArchived = {}) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_CRITERIAS_LOADING, payload: true });
    const raw = typeof paramsOrIncludeArchived === 'boolean'
      ? { include_archived: paramsOrIncludeArchived }
      : (paramsOrIncludeArchived || {});
    const params = Object.fromEntries(
      Object.entries(raw).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/criteria?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_CRITERIAS_LIST, payload });
    }
    dispatch({ type: SET_CRITERIAS_LOADING, payload: false });
  }
}

export const createEntity = (data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_CRITERIAS_LOADING, payload: true });
    const response = await fetch(`${BACKEND_URL_PREFIX}/criteria`, {
      method: "POST",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState)
    });
    let success = false;
    if (response.ok) {
      success = true;
    } else {
      const body = await response.json().catch(() => ({}));
      body.error && createNotification('error', body.error);
    }
    dispatch({ type: SET_CRITERIAS_LOADING, payload: false });
    return success;
  }
  return false;
}

export const updaateEntity = (id, data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_CRITERIAS_LOADING, payload: true });
    const response = await fetch(`${BACKEND_URL_PREFIX}/criteria/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState)
    });
    let success = false;
    if (response.ok) {
      success = true;
    } else {
      const body = await response.json().catch(() => ({}));
      body.error && createNotification('error', body.error);
    }
    dispatch({ type: SET_CRITERIAS_LOADING, payload: false });
    return success;
  }
  return false;
}

export const deleteEntity = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_CRITERIAS_LOADING, payload: true });
    const response = await fetch(`${BACKEND_URL_PREFIX}/criteria/${id}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch(getList({ include_archived: true }));
    }
    dispatch({ type: SET_CRITERIAS_LOADING, payload: false });
  }
}

export const reorderCriteria = (category, orderedIds) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/criteria/reorder`, {
      method: "PUT",
      body: JSON.stringify({ category, ordered_ids: orderedIds }),
      ...buildDefaultHeaders(getState)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      createNotification('error', body.error || 'Ошибка сохранения порядка');
    }
  }
}
